// src/components/gavion/integrations/api/M365ApiContext.tsx
import { createContext, useContext, type ReactNode } from "react";
import type { M365Api } from "./types";
import { unavailableM365Api } from "./unavailableM365Api";

const Ctx = createContext<M365Api>(unavailableM365Api());
export const M365ApiProvider = ({
  api,
  children,
}: {
  api: M365Api;
  children: ReactNode;
}) => <Ctx.Provider value={api}>{children}</Ctx.Provider>;
export const useM365Api = (): M365Api => useContext(Ctx);
